
import React, { useState, useEffect, memo, useMemo, useRef } from 'react';
import ValuesStore from '../../store/values-store';
import { useSearchParams, Link, useLocation, useNavigate } from 'react-router-dom';
import utils from '../../dependencies/custom/react-utilities';
import { Button, Watermark, Select, Space, Tabs, Input, Tooltip } from 'antd';
import Settings from '../../dependencies/custom/settings';
import ReactToPrint from 'react-to-print';
import CustomFunction from '../../dependencies/custom/custom-functions';

import useTable from '../../hooks/table';

import AppContainer from '../../components/container';

const GradeDelete = (props) => {
    const { filters, filterTypes } = utils.generateTableFilters();
    const [indexNumbers, setIndexNumbers] = useState();
    const [grade, setGrade] = useState();
    const [courses, setCourses] = useState();
    const [acadyr, setAcadYr] = useState('');
    const [location, setLocation] = useState();
    const [loading, setLoading] = useState(false);

    const table = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 25,
                position: ['bottomRight'],
                hideOnSinglePage: true
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        undefined,
        undefined,
        undefined,
        undefined,
        'id',
        {},
        {});


    const columns = ([
        {
            title: 'IndexNo.',
            dataIndex: 'index_no',
            ...table.getColumnSearchProps('index_no'),
        },
        {
            title: 'Firstname',
            dataIndex: 'fname',
            ...table.getColumnSearchProps('fname'),
        },
        {
            title: 'Lastname',
            dataIndex: 'lname',
            ...table.getColumnSearchProps('lname'),
        },
        {
            title: 'Middlename',
            dataIndex: 'mname',
            ...table.getColumnSearchProps('mname'),
        },
        {
            title: 'Course',
            dataIndex: 'course_code',
            filterSearch: true,
            render: (v, record) => record.course_name
        },
        {
            title: 'AcadYr',
            dataIndex: 'acad_year',
            ...table.getColumnSearchProps('acad_year'),
        },
        {
            title: 'Grade',
            dataIndex: 'grade',
        }
    ]);

    useEffect(() => {
        table.setColumns(columns);
    }, []);



    // const items = [
    //     {
    //         key: '1',
    //         label: `Delete Grades`,
    //         children: [
    //             gradeDeleteFilter()
    //         ]
    //     },
    //     {
    //         key: '2',
    //         label: `Delete Course & Grades`,
    //         children: []
    //     }
    // ];

    async function query() {
        let res = await utils.requestWithReauth('post', `${Settings.backend}/get_grades_to_delete`, null, { indexNumbers, courses, grade, acadyr, location });
        if (res?.result) {
            table.setData(res?.result);
        } else {
            utils.showNotification(undefined, res?.msg);
        }
    }

    async function deleteRecords() {
        setLoading(true);
        let res = await utils.requestWithReauth('post', `${Settings.backend}/delete_grades`, null, { indexNumbers, courses, grade, acadyr, location });
        if (res?.status == 'Ok') {
            utils.showNotification(undefined, 'Operation successful', 'text-success');
            table.setData([]);
        } else {
            utils.showNotification(undefined, res?.msg);
        }
        setLoading(false);
    }

    async function deleteAllUnregIC() {
        setLoading(true);
        let res = await utils.requestWithReauth('post', `${Settings.backend}/delete_all_unreg_ic`);
        if (res?.status == 'Ok') {
            utils.showNotification(undefined, `Operation successful. Affects Rows: ${res?.affectedRows}`, 'text-success');
        } else {
            utils.showNotification(undefined, res?.msg);
        }
        setLoading(false);
    }

    function gradeDeleteFilter() {
        return <div key='filters' className='mt-2 row'>
            <div className='col-md-3'>
                Academic Year
                <Input value={acadyr} onChange={e => setAcadYr(e.target.value)}
                    placeholder='Enter Academic Year'
                />
            </div>
            <div className='col-md-3'>
                Index Number
                <Select
                    mode="tags"
                    style={{ width: '100%' }}
                    tokenSeparators={[',']}
                    onChange={setIndexNumbers}
                    placeholder='Enter Index Number(s)'
                />
            </div>

            <div className='col-md-3'>
                Grade
                <Select
                    style={{ width: '100%' }}
                    options={[
                        { value: 'IC', label: 'IC' },
                        { value: 'E', label: 'E' },
                        { value: 'D', label: 'D' },
                        { value: 'D+', label: 'D+' },
                        { value: 'C', label: 'C' },
                        { value: 'C+', label: 'C+' },
                        { value: 'B', label: 'B' },
                        { value: 'B+', label: 'B+' },
                        { value: 'A', label: 'A' },
                    ]}
                    onChange={setGrade}
                    placeholder='Enter Grade'
                />
            </div>
            <div className='col-md-3'>
                Course Code
                <Select
                    mode="tags"
                    style={{ width: '100%' }}
                    tokenSeparators={[',']}
                    onChange={setCourses}
                    placeholder='Enter Course Code'
                />
            </div>
            <div className='col-md-3 mt-2'>
                Location
                <Select
                    style={{ width: '100%' }}
                    options={[
                        { value: 'scoresheet_summary', label: 'On Sheet' },
                        { value: 'scoresheet_summary_extra', label: 'Back Door' }
                    ]}
                    onChange={setLocation}
                    placeholder='Enter Grade'
                />
            </div>

            <div className='col-md-12 mt-3'>
                <Space>
                    <Button type='primary' onClick={e => query()}>Query</Button>
                    <Button className='btn-danger' loading={loading} onClick={e => deleteRecords()}>Delete</Button>
                </Space>
            </div>
        </div>
    }

    function caption(data) {
        return <label>Total Count:{data?.length}</label>
    }



    return (
        <>
            <AppContainer
                extra={
                    <div className='mb-2'>
                        <Tooltip title='This action deletes all ICs for course student did not registered'>
                            <Button loading={loading} className='me-2 btn-danger border-0' onClick={e => deleteAllUnregIC()} icon={<i className='fas fa-trash' />}>DELETE IC FOR UNREGISTERED COURSES</Button>
                        </Tooltip>
                    </div>
                }
                title={'Delete Grades'}
                children={
                    <>
                        {/* <Tabs defaultActiveKey="1" items={items} /> */}
                        {gradeDeleteFilter()}
                        {table.tableWithHeaderFooter(caption, caption)}
                    </>
                }
            />

        </>
    );
}

export default memo(GradeDelete);